<template>
  <div class="product-card">
    <GFMP
      :wrapper-styles="{ width: '100%', aspectRatio: '1/1' }"
      :styles="{ ...fmpStyles.rounded, height: '100%', width: '100%' }"
    />
    <div class="product-card-content">
      <div class="product-card-content-text">
        <GFMP v-for="_i in 3" :key="_i" :styles="{ ...fmpStyles.rounded, width: `${30 + Math.random() * 70}%` }" />
      </div>
      <div class="product-card-content-rating">
        <GFMP
          v-for="_i in 3"
          :key="_i"
          :styles="{ ...fmpStyles.rounded, minWidth: `${_i * 12}px`, ...(_i === 1 && fmpStyles.circle) }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-card-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

@mixin flexColumn {
  display: flex;
  flex-direction: column;
}

.product {
  &-card {
    @include flexColumn();
    gap: 24px;
    width: 100%;

    &-content {
      @include flexColumn();
      gap: 16px;

      &-text {
        @include flexColumn();
        gap: 8px;
      }

      &-rating {
        display: flex;
        gap: 8px;
      }
    }
  }
}
</style>
